import sectionItemsGrid05Css from '../css-snippets/section-items-grid-05';

const html = `
<style>${sectionItemsGrid05Css}</style>
<div
  id="items-grid-section-unique-id"
  data-id="unique-id"
  class="items-grid-wrapper"
  data-attribute="items-grid-wrapper"
  data-background-color="#ffffff"
  data-text-color="#000000"
  data-card-background-color="#ffffff"
  data-card-text-color="#000000"
  data-top-padding="true"
  data-bottom-padding="true"
  data-background-image="false"
  data-card-border-radius="0"
  data-item-image-width-desktop="75"
  data-item-image-width-mobile="75"
  data-show-number="false"
  data-items-grid-list-width="75"
  data-image-show="true"
  data-image-position="left"
  style="
    --background-color: #ffffff;
    --text-color: #000000;
    --card-text-color: #000000;
    --card-background-color: #ffffff;
    --card-border-radius: 0px;
    --item-image-width-desktop: 75px;
    --item-image-width-mobile: 75px;
     --items-grid-list-width: 75%;
  "
>
  <div
    data-attribute="items-grid-content"
    class="items-grid-content container"
    data-container-full-width="false"
  >
    <div data-attribute="title-content" class="items-grid-header">
      <h2 style="text-align: center">
        <strong>6 Respiratory Healing Properties</strong>
      </h2>
    </div>
    <div class="items-grid-list-wrapper">
      <div class="items-grid-list-image" data-attribute="items-grid-image">
        <img
          data-attribute="items-grid-image-inner"
          src="https://cdn.skyfastimg.com/images/2026/04/09/image-69d77c0715765c280f672947.png?w=500&h=50&q=80"
          alt="img"
        />
      </div>
      <div
        data-attribute="items-grid-list"
        class="items-grid-list"
        data-items-per-row-mobile="2"
        data-items-per-row-desktop="1"
        style="
          --items-per-row-mobile: 2;
          --items-per-row-desktop: 1;
        "
      >
        <div data-attribute="items-grid-item" class="items-grid-item">
          <div class="items-grid-item-number" data-attribute="number-item">
            1.
          </div>
          <div class="items-grid-item-image">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/04/09/image-69d77c5ced502dd820daacde.png?w=50&h=50&q=80"
              alt="img"
            />
          </div>
          <div data-attribute="text-item" class="items-grid-item-text">
            <p><span class="text-big">Anti-Inflammatory</span></p>
          </div>
        </div>

        <div data-attribute="items-grid-item" class="items-grid-item">
          <div class="items-grid-item-number" data-attribute="number-item">
            2.
          </div>
          <div class="items-grid-item-image">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/04/09/image-69d77c6cd2c0898ecac09c1a.png?w=50&h=50&q=80"
              alt="img"
            />
          </div>
          <div data-attribute="text-item" class="items-grid-item-text">
            <p><span class="text-big">Anti-Asthmatic</span></p>
          </div>
        </div>

        <div data-attribute="items-grid-item" class="items-grid-item">
          <div class="items-grid-item-number" data-attribute="number-item">
            3.
          </div>
          <div class="items-grid-item-image">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/04/09/image-69d77c78aac3ed06d5769ae3.png?w=50&h=50&q=80"
              alt="img"
            />
          </div>
          <div data-attribute="text-item" class="items-grid-item-text">
           <p><span class="text-big">Anti-Illness</span></p>
          </div>
        </div>

        <div data-attribute="items-grid-item" class="items-grid-item">
          <div class="items-grid-item-number" data-attribute="number-item">
            4.
          </div>
          <div class="items-grid-item-image">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/04/09/image-69d77c78aac3ed06d5769ae3.png?w=50&h=50&q=80"
              alt="img"
            />
          </div>
          <div data-attribute="text-item" class="items-grid-item-text">
            <p><span class="text-big">Anti-Oxidant</span></p>
          </div>
        </div>

        <div data-attribute="items-grid-item" class="items-grid-item">
          <div class="items-grid-item-number" data-attribute="number-item">
            5.
          </div>
          <div class="items-grid-item-image">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/04/09/image-69d77caf604d1991317efec3.png?w=50&h=50&q=80"
              alt="img"
            />
          </div>
          <div data-attribute="text-item" class="items-grid-item-text">
            <p><span class="text-big">Anti-Microbial</span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
